



function mainSlider() {


    if( jQuery(".owl-carousel").length ){


        if (jQuery(".picscrl-tpl-s1 .owl-carousel").length) {


            jQuery('.js-inimg-s1').owlCarousel({
                items: 1,
                loop: true,
                autoplay: true,
                autoplayTimeout:70000,
                autoplayHoverPause: true,
                dots: true,
                nav: false,
                animateIn: 'fadeIn',
                animateOut: 'fadeOut',
                navText: ["<i class='nf nf-larrw'></i>", "<i class='nf nf-rarrw'></i>"],

                responsive:{
                    992:{
                        nav: true,
                    },
                }
            });
        }
    }
};





export {mainSlider}
